import { Box, Typography } from "@mui/material";

interface AssignHistoryItem {
  "Assigned to": string;
  Date: string;
}

const FormatAssignHistoryData = (assignedData: string) => {
  const data: AssignHistoryItem[] = JSON.parse(assignedData);
  return data?.map((item, index) => {
    // Convert values to strings explicitly to avoid [object Object] stringification
    const assignedTo = String(item["Assigned to"] ?? "");
    const date = String(item["Date"] ?? "");

    // Use index as fallback for unique key in case values are empty
    const uniqueKey = `${assignedTo}-${date}-${index}`;

    return (
      <Box key={uniqueKey} mb={2} className="assignee-history">
        <Typography variant="body2">
          Assigned to : <span>{item["Assigned to"]}</span> on{" "}
          <span>{item["Date"]}</span>
        </Typography>
      </Box>
    );
  });
};

export default FormatAssignHistoryData;
